/** What every system receives each tick, plus the two questions asked about a soldier everywhere. */

import type { Pcg32 } from './rng';
import type { Statics } from './statics';
import type { Command, Enemy, SimEvent, World } from './types';

export interface Ctx {
  world: World;
  statics: Statics;
  rng: Pcg32;
  events: SimEvent[];
  cmd: Command;
  /** Set when a prop was destroyed this tick: colliders and nav grid must be rebuilt. */
  staticsDirty: boolean;
}

/** Still breathing (a wounded man is alive but out of the fight). */
export const isAlive = (e: Enemy): boolean => e.state !== 'dead';

/** Able to see, move and shoot. */
export const isFighter = (e: Enemy): boolean => e.state !== 'dead' && e.state !== 'wounded';
